export const TERMS_OF_SERVICE_URL = "https://clipboardhealth.com/terms-of-service";
export const PRIVACY_POLICY_URL = "https://clipboardhealth.com/privacy-policy";
